import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../ConfigFields/SelectField';

export function CreatePatientOrderFormFields() {
  return (
    <ParentBlockSelectField
      fieldName="config.payload"
      label="Patient Order"
      helperText={getSourceBlockNameHelperText('patient order')}
    />
  );
}
